import { render, staticRenderFns } from "./DashboardHistory.vue?vue&type=template&id=2d014616&scoped=true"
import script from "./DashboardHistory.vue?vue&type=script&lang=js"
export * from "./DashboardHistory.vue?vue&type=script&lang=js"
import style0 from "./DashboardHistory.vue?vue&type=style&index=0&id=2d014616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d014616",
  null
  
)

export default component.exports